import type { AbsenceListItem } from "@msuite/utils/types";
import React from "react";

/** Props Interface */
interface UserCalendarAbsenceItemProps {
	item: AbsenceListItem;
}

export function UserCalendarAbsenceItem({ item }: UserCalendarAbsenceItemProps) {
	/** Render */
	return (
		<React.Fragment>
			<p>{item.name}</p>
		</React.Fragment>
	);
}
